import "Layouts/default";

import { updateLazy } from "Functions/lazy";
import { scrollToEl } from "Functions/anchor";

import "Ui/slider";

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll(".pager__list .c-btn")) {
        if (pagerButton.classList.contains("is-active")) continue;

        pagerButton.addEventListener("click", (event) => {
            scrollToEl(document.querySelector(".js-listing-scroll-here"), 20);
        });
    }
};

rEvent.on("Listing.fetchedData", () => {
    updateLazy();
    attachPaginatorEvents();

    if ($(".js-pager-current-count").length) {
        $(".js-pager-current-count").html(
            $(".listing.promotionmicrosites").first().find(".listing__item").length
        );
    }
});

attachPaginatorEvents();
